import React from "react";
import WrenchesImage from "../../../assets/images/wrenches.jpeg";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import HeroSearch from "./HeroSearch";


export default function Hero() {

    const { t } = useTranslation();

    const { isDesktop, isMobile, isTablet } = useWindowSize();

    return (
        <Box className="hero"
            sx={{
                // backgroundImage: `linear-gradient(rgba(0, 60, 89, 0.5), rgba(0, 45, 70, 0.4)), url(${WrenchesImage})`,
                backgroundImage: `linear-gradient(rgba(0, 60, 89, 0.8), rgba(0, 60, 89, 0.6)), url(${WrenchesImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                // height: isMobile ? 'auto' : (isTablet ? 'auto' : '110%')
            }}
        >
            <Box className="hero-content">
                <Box className="hero-text">
                    <Box className="hero-header">
                        <Typography className="main-header"
                            variant={isMobile ? "h4" : isTablet ? "h3" : "h2"} 
                            component="h1" 
                            sx={{ textAlign: 'center', fontWeight: 'bold' }} 
                        >
                            {t('HeaderInfo.headerInfoHeader1')} <Typography component={'span'} variant={"inherit"} className="accent-color">{t('HeaderInfo.headerInfoHeader2')}</Typography> {t('HeaderInfo.headerInfoHeader3')}
                        </Typography>
                        <Typography className="sub-header"
                            variant={isMobile ? "h5" : isTablet ? "h4" : "h3"} 
                            component="h2" 
                            sx={{ textAlign: 'center', marginTop: 2 }}
                        >
                            {t('hero.headerSubText')}
                        </Typography>
                    </Box>
                    <Box className="hero-subtext" sx={{ maxWidth: 600, margin: '40px auto 0 auto' }}>
                        <Typography className="sub-header"
                            variant={isMobile ? "body1" : "h6"} 
                            component="p" 
                            sx={{ textAlign: 'center', fontSize: isMobile ? '0.8rem' : '1.1rem' }}
                        >
                            {t('hero.headerSubText2')}
                        </Typography>
                    </Box>
                </Box>
                <HeroSearch />
                <Box className="hero-features sub-header">
                    <Typography variant="p" component="p" sx={{ fontSize: '0.8rem', textAlign: 'center' }}>
                        ✓ {t('hero.extraText1')}  •  ✓ {t('hero.extraText2')}  •  ✓ {t('hero.extraText3')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}